import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import PersonIcon from '@mui/icons-material/Person';
import { selectOrdersPinnedFilters, togglePinnedFiltersState } from '@store';
import { useHasFilters } from 'hooks/common';

export const useOrdersFilterConfig = ({ statuses }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectOrdersPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'status',
        label: 'Status',
        icon: PersonIcon,
        options: statuses || [],
      },
    ],
    [statuses]
  );

  const currentFilters = useMemo(() => {
    return {
      status: router.query.status,
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'orders', pinnedFilter }));
  };

  const { hasFilters } = useHasFilters({
    pinnedFilters,
  });

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
  };
};

export default useOrdersFilterConfig;
